import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useMe, useRouteNavigate } from "@madmedical/user";
import { Icon } from "@madmedical/ui";
import { UnderlyingCondition } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
const getIcon = (name) => {
    const IconWrap = (props) => _jsx(Icon, Object.assign({ name: name }, props));
    IconWrap.displayName = "Icon";
    return IconWrap;
};
export default () => {
    var _a, _b;
    const navigate = useRouteNavigate();
    const { patient, roles: { isDoctor, isPatient, isRepresentative, isHotline, isAdmin }, } = useMe();
    const { t } = useTranslation();
    const doctorMenu = useMemo(() => [
        {
            Icon: getIcon("user"),
            title: t("patients"),
            onPress: () => navigate("patients", {}),
        },
        {
            Icon: getIcon("activity"),
            title: t("measures:title"),
            onPress: () => navigate("patients_measurements", {
                byPeriod: "day",
            }),
        },
    ], [navigate, t]);
    const isBasic = !((_a = patient === null || patient === void 0 ? void 0 : patient.packages) === null || _a === void 0 ? void 0 : _a.some((p) => p.type !== "basic"));
    const isInsulin = (patient === null || patient === void 0 ? void 0 : patient.underlyingConditions.includes(UnderlyingCondition.Insulin)) &&
        ((_b = patient === null || patient === void 0 ? void 0 : patient.packages) === null || _b === void 0 ? void 0 : _b.some((p) => p.type === "diabetes"));
    const patientMenu = useMemo(() => [
        {
            Icon: getIcon("heart"),
            title: t("health"),
            onPress: () => navigate("dashboard", {}),
        },
        {
            Icon: getIcon("user"),
            title: t("devices"),
            onPress: () => navigate("devices_connected", {}),
        },
        ...(!isBasic
            ? [
                {
                    Icon: getIcon("reportData"),
                    title: t("results"),
                    onPress: () => navigate("opinions", {}),
                },
                ...(isInsulin
                    ? [
                        {
                            Icon: getIcon("alarm"),
                            title: t("reminders"),
                            onPress: () => navigate("insulin_reminders", {}),
                        },
                    ]
                    : []),
                {
                    Icon: getIcon("documentAttachment"),
                    title: t("documents"),
                    onPress: () => navigate("documents_opinion", {}),
                },
                {
                    Icon: getIcon("settings"),
                    title: t("authorizedPersons"),
                    onPress: () => navigate("representatives", {}),
                },
            ]
            : []),
    ], [isBasic, isInsulin, navigate, t]);
    console.log(patientMenu);
    const representativeMenu = useMemo(() => [
        {
            Icon: getIcon("heart"),
            title: t("health"),
            onPress: () => navigate("dashboard", {}),
        },
        {
            Icon: getIcon("reportData"),
            title: t("results"),
            onPress: () => navigate("opinions", {}),
        },
        {
            Icon: getIcon("documentAttachment"),
            title: t("documents"),
            onPress: () => navigate("documents_opinion", {}),
        },
    ], [navigate, t]);
    return useMemo(() => isRepresentative && !isPatient
        ? [...representativeMenu]
        : [
            ...(isDoctor || isHotline || isAdmin ? doctorMenu : []),
            ...((isPatient && isRepresentative) || isPatient
                ? patientMenu
                : []),
        ], [
        isDoctor,
        isPatient,
        isRepresentative,
        isHotline,
        isAdmin,
        doctorMenu,
        patientMenu,
        representativeMenu,
    ]);
};
